import React, { useMemo, useState, useEffect } from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import { getAdminStats, getAdminDashboard } from "../../actions/adminAction";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { Line, Pie } from "react-chartjs-2";
import moment from "moment";
import randomColor from "randomcolor";
import { Link, useLocation } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import InitializeLocalStorage from "../../components/PaginationHandle";
import ConsultationChart from "../../charts/lineChart/recentConsultaionChart";
import DoctorStatChart from "../../charts/barChart/doctorStatChart"
import circleCheck from "../../assets/images/check-circle.svg";
import pendingConsultation from "../../assets/images/pending-consultation.svg";
import circleCross from "../../assets/images/circle-cross.svg";
import moneyBill from "../../assets/images/dollar-note.svg";
import paidConsultation from "../../assets/images/paid-consultation-icon.svg";
import totalConsultations from "../../assets/images/total-paid-consultation.svg";

function createHtmlLegendPlugin(containerId) {
  return {
    id: "htmlLegend",
    afterUpdate(chart) {
      const legendContainer = document.getElementById(containerId);
      if (!legendContainer) return;

      // Clear existing legend
      while (legendContainer.firstChild) {
        legendContainer.firstChild.remove();
      }

      const ul = document.createElement("ul");
      ul.className = "pie-legend-list";
      legendContainer.appendChild(ul);

      const items =
        chart?.options?.plugins?.legend?.labels?.generateLabels?.(chart) || [];

      items.forEach((item) => {
        const li = document.createElement("li");
        li.className = `pie-legend-item${item.hidden ? " is-hidden" : ""}`;

        li.onclick = () => {
          chart.toggleDataVisibility(item.index);
          chart.update();
        };

        const box = document.createElement("span");
        box.className = "pie-legend-box";
        box.style.background = item.fillStyle;
        box.style.borderColor = item.strokeStyle;

        const text = document.createElement("span");
        text.className = "pie-legend-text";
        text.textContent = item.text;

        li.appendChild(box);
        li.appendChild(text);
        ul.appendChild(li);
      });
    },
  };
}

function useIsMobile(maxWidth = 767) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const onChange = (e) => setIsMobile(e.matches);

    // Ensure initial value is synced
    setIsMobile(mql.matches);

    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);

    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [maxWidth]);

  return isMobile;
}

const Index = () => {
  const [dailyStats, setDailyStats] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loader1, setLoader1] = useState(false);

  const [totalPaid, setTotalPaid] = useState(0);
  const [dailyPaid, setDailyPaid] = useState(0);
  const [paid, setPaid] = useState(0);
  const [pending, setPending] = useState(0);
  const [declined, setDeclined] = useState(0);
  const [lineChartData, setLineChartData] = useState();
  const [pieChart, setPieChart] = useState();
  const location = useLocation();
  const { pathname } = location;
  const { admin } = useSelector((state) => state.admin);
  const currentUserRole = admin.role;
  InitializeLocalStorage(pathname, localStorage.getItem("currentURL"));
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
  );

  const pieLegendContainerId = "pie-disease-legend";
  const isMobile = useIsMobile(767);
  const pieOptions = useMemo(
    () => ({
      responsive: true,
      // Desktop: keep default look. Mobile: allow us to control height + avoid cut text.
      maintainAspectRatio: !isMobile,
      plugins: {
        // Desktop: use Chart.js default legend (as before). Mobile: use scrollable HTML legend.
        legend: { display: !isMobile },
      },
    }),
    [isMobile]
  );
  const pieHtmlLegendPlugin = useMemo(
    () => createHtmlLegendPlugin(pieLegendContainerId),
    []
  );

  const getAllstatDashboard = async () => {
    setLoader1(true);
    let res = await getAdminDashboard();
    if (res?.data) {
      setPaid(res?.data?.Paid);
      setPending(res?.data?.pending);
      setDeclined(res?.data?.declined);
      setDailyStats(res?.data?.todayPaidCount);
      setDailyPaid(res?.data?.todayPaid[0]?.totalPrice);
      setTotalPaid(res?.data?.totalPaid[0]?.totalPrice);
      setLoader1(false);
    }
  };

  useEffect(() => {
    getAllStats();
    getAllstatDashboard();
  }, []);
  const options = {
    responsive: true,
    scales: {
      y: {
        ticks: {
          beginAtZero: true,
          callback: function (value) {
            if (value % 1 === 0) {
              return value;
            }
          },
        },
      },
    },
  };

  const getAllStats = async () => {
    setLoader(true);
    let res = await getAdminStats();
    if (res?.data) {
      let data = [];
      let labels = [];
      let paid = [];
      let unpaid = [];
      let declined = [];
      res.data?.orderChartData?.forEach((data_, index) => {
        data.push(data_?.appointments);
        declined.push(data_?.declined);
        paid.push(data_?.paid);
        unpaid.push(data_?.unpaid);
        const date = moment(data_?.first).add(1, "day");
        labels.push(date.format("MM-DD-YYYY"));
      });

      // setLineChartData({
      //   labels,
      //   datasets: [
      //     {
      //       label: "Paid",
      //       data: paid,
      //       borderColor: "rgba(135, 203, 22 , 1)",
      //       backgroundColor: "rgba(135, 203, 22, 1)",
      //     },

      //     {
      //       label: "Unpaid",
      //       data: unpaid,
      //       borderColor: "rgba(255, 193, 7 , 1)",
      //       backgroundColor: "rgba(255, 193, 7, 1)",
      //     },
      //     {
      //       label: "Declined",
      //       data: declined,
      //       borderColor: "rgba(251, 64, 75,1)",
      //       backgroundColor: "rgba(251, 64, 75, 1)",
      //     },
      //   ],
      // });

      const backgroundColors = res.data.chartLabels.map(() =>
        randomColor({ luminosity: "light" })
      );

      const borderColors = backgroundColors.map((color) =>
        color.replace("0.2", "1")
      );
      const pieData = {
        labels: res?.data?.chartLabels,
        datasets: [
          {
            label: "# of Appointments",
            data: res.data.chartData,
            backgroundColor: backgroundColors,
            borderColor: borderColors,
            borderWidth: 1,
          },
        ],
      };

      setPieChart(pieData);
      setLoader(false);
    }
  };

  return (
    <>
      <div className="pt-2 pt-md-3 main-dashboard ">
        
        {loader1 ? (
          <FullPageLoader />
        ) : (
          <Container fluid>
            <div className="pl-0 mb-4">
          <Card.Title  className="card-title mb-0" as="h4">
          Dashboard Overview
        </Card.Title>
  
            
          </div>
            {currentUserRole.viewMathmaticalStat ?
            <Row>
              <>
                <Col xl={4} md={6}>
                   <Link to="/consultations?isPaid=paid" className="card-stat-link">
                  <Card className="card-stats">
                    
                    <Card.Body>
                   
                        <div className="numbers">
                          <p className="card-category">Paid Consultations</p>
                        </div>
                        <div className="icon-big text-center icon-warning">
                          {/* <i className="far fa-check-circle"></i> */}
                          <img src={circleCheck} alt="circle-check" />
                        </div>
                        <Card.Title as="h2">{paid ?? 0}</Card.Title>
                     
                    </Card.Body>
                  
                  </Card>
                     </Link>
                </Col>
                <Col xl={4} md={6}>
                  <Link
                        to="/consultations?isPaid=notpaid"
                      >
                  <Card className="card-stats">
                    <Card.Body>
                    
                        <div className="numbers">
                          <p className="card-category">Pending Consultations</p>
                        </div>
                        <div className="icon-big text-center icon-warning">
                          {/* <i className="fa fa-undo"></i> */}
                          <img src={pendingConsultation} alt="pending-consultation" />
                        </div>
                        <Card.Title as="h2">{pending ?? 0}</Card.Title>
                     
                    </Card.Body>
                  </Card>
                   </Link>
                </Col>
                <Col xl={4} md={6}>
                 <Link
                        to="/consultations?isPaid=declined"
                        className=""
                      >
                  <Card className="card-stats">
                    <Card.Body>
                     
                        <div className="numbers">
                          <p className="card-category">
                            {" "}
                            Declined Consultations
                          </p>
                        </div>
                        <div className="icon-big text-center icon-warning">
                          {/* <i className="fa fa-ban"></i> */}
                          <img src={circleCross} alt="circle-cross" />
                        </div>
                        <Card.Title as="h2">{declined ?? 0}</Card.Title>
                    
                    </Card.Body>
                  </Card>
                    </Link>
                </Col>
              </>
              <>
                <Col xl={4} md={6}>
                  <Card className="card-stats">
                    <Card.Body>
                      <div className="d-flex justify-content-between">
                        <div className="numbers">
                          <p className="card-category">
                            Total Amount of Paid Consultations
                          </p>
                        </div>
                        <div className="icon-big text-center icon-warning">
                          {/* <i className="fas fa-money-bill"></i> */}
                          <img src={moneyBill} alt="money-bill" />
                        </div>
                      </div>
                      <Card.Title as="h2">
                            {totalPaid?.toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 2,
                            }) ?? "$0.00"}{" "}
                          </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xl={4} md={6}>
                  <Card className="card-stats">
                    <Card.Body>
                      <div className="d-flex justify-content-between">
                        <div className="numbers">
                          <p className="card-category">
                            Today Paid Consultations Payment
                          </p>
                        </div>
                        <div className="icon-big text-center icon-warning">
                          {/* <i className="fa fa-hospital-user"></i> */}
                          <img src={paidConsultation} alt="paid-consultation" />
                        </div>
                      </div>
                      <Card.Title as="h2">
                        {dailyPaid?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                        }) ?? "$0.00"}{" "}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              </>

              <Col xl={4} md={6}>
                <Card className="card-stats">
                  <Card.Body>
                    <div className="d-flex justify-content-between">
                      <div className="numbers">
                        <p className="card-category">
                          Today Paid Consultations
                        </p>
                        
                      </div>
                      <div className="icon-big text-center icon-warning">
                        {/* <i className="far fa-handshake"></i> */}
                        <img src={totalConsultations} alt="total-consultations" />
                      </div>
                    </div>
                    <Card.Title as="h2">{dailyStats ?? 0}</Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            :""}
            {loader ? (
              <Skeleton count={20} />
            ) : (

              <Row>
                {currentUserRole.viewDoctorBarChart ?
                <Col xl={7} lg={6}>
                  <DoctorStatChart/>
                </Col>
                :""
                }
                {currentUserRole.viewConsultationsPieChart ?
                <Col xl={5} lg={6} className="pie-chart-wrap">
                   <div className="card-stats card chart-card">
                      <div className="chart-card-header">
                        <h4 className="card-title">Consultations by Disease</h4>
                      </div>
                      {isMobile && (
                        <div
                          id={pieLegendContainerId}
                          className="pie-legend-scroll"
                        />
                      )}
                      <div className={isMobile ? "pie-chart-canvas-wrap" : undefined}>
                        {pieChart && (
                          <Pie
                            data={pieChart}
                            options={pieOptions}
                            plugins={isMobile ? [pieHtmlLegendPlugin] : undefined}
                          />
                        )}
                      </div>
                    </div>
                </Col>
                  :""
                  }
                {currentUserRole.viewConsultationsLineChart ?
                <Col xl={12} lg={12} className="mt-3">
                  <ConsultationChart/>
                </Col>
                  :""
                }
              </Row>
            )}
          </Container>
        )}
      </div>
    </>
  );
};

export default Index;
